<div class="text-right">
  <gung-button
    classes="btn-primary btn-sm mb-2"
    label="{{ 'CREATE_CONTACT' | translate }}"
    [onClick]="create.bind(this)"
  />
</div>
@if (!loading) {
  <gung-table [config]="contactTable"></gung-table>
} @else {
  <div class="d-flex justify-content-center">
    <div class="spinner-border" role="status">
      <span class="sr-only">Loading...</span>
    </div>
  </div>
}
